import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { useAppSelector } from '../../hooks';
import { TProviderSourceList, TProviderSourceListResponse, TProviderSourceQuery, adaptProviderListSourceQueryToRequest, adaptProviderSourceFromListResponse } from '../../types';
import { BACKEND_SOURCE_PROVIDER } from '../../backend-paths';


export const sourceProviderGetApi = createAsyncThunk(
	BACKEND_SOURCE_PROVIDER,
	(payload: TProviderSourceQuery | undefined, thunkApi) => {
		const params = adaptProviderListSourceQueryToRequest(payload);

		return HttpService.get<TProviderSourceListResponse>(BACKEND_SOURCE_PROVIDER, { params }).then(result => {
			return adaptProviderSourceFromListResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	isLoading: boolean;
	list: TProviderSourceList;
	query: TProviderSourceQuery;
	error?: HttpError;
};

const initialState: TInitialState = {
	isLoading: false,
	list: {
		items: [],
		count: 0,
	},
	query: {
		limit: 50,
		offset: 0,
		search: undefined,
	},
	error: undefined,
};

export const sourceProviderSlice = createSlice({
	name: 'sourceProviderSlice',
	initialState,
	reducers: {
		setSourceProviderQuerySearch(state, action: PayloadAction<string>) {
			const search = action.payload || undefined;
			const isSearch = search && search.length > 0;

			if (isSearch && state.query.offset !== 0) {
				state.query.offset = 0;
				return;
			}

			state.query.search = search;
		},

		clearSourceProvider(state) {
			return { ...initialState, list: state.list, query: state.query };
		},
	},

	extraReducers: {
		[sourceProviderGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[sourceProviderGetApi.fulfilled.type]: (state, action: PayloadAction<TProviderSourceList>) => {
			state.isLoading = false;
			state.list = action.payload;
			state.error = undefined;
		},

		[sourceProviderGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useSourceProviderSelector = () => useAppSelector(state => state[sourceProviderSlice.name]);

export const { clearSourceProvider, setSourceProviderQuerySearch } = sourceProviderSlice.actions;
